/*
    Create by fanglijuan 2017-05-16
*/
'use strict';
angular.module("createPersonalCenterConfigModule", [])
    .controller("createPersonalCenterConfigCtrl", ["$scope", "$timeout", "$q", "$validation", "trsHttpService", '$modalInstance', "personalCenterConfigService", "trsspliceString", "modalDialog", "personalCenterConfig",
        function($scope, $timeout, $q, $validation, trsHttpService, $modalInstance, personalCenterConfigService, trsspliceString, modalDialog, personalCenterConfig) {
            initStatus();
            initData();

            /**
             * [initStatus description]初始化参数
             */
            function initStatus() {
                $scope.data = {
                    currPersonalConfig: personalCenterConfig ? angular.copy(personalCenterConfig) : {},
                };
                $scope.status = {
                    modalTitle: personalCenterConfig ? "修改模块" : "添加模块",
                    isCreate: personalCenterConfig ? false : true,
                    minNumber: 300, //刷新秒数最小值
                    maxNumber: 99999, //刷新秒数最大值
                };
                $scope.visibles = [{
                    "desc": "是",
                    "value": 1,
                    "isSelected": true
                }, {
                    "desc": "否",
                    "value": 0,
                    "isSelected": false
                }];
                $scope.isVisible = personalCenterConfig ? personalCenterConfig.VISIBLE : $scope.visibles[0].value;

                $scope.personalConfigJson = [];
            }

            function initData() {
                initAllPersonalConfigs();
            }

            //确定
            $scope.confirm = function() {
                $validation.validate($scope.createPersonalConfigSubmitForm).success(function() {
                    savePersonalConfig($scope.data.currPersonalConfig).then(function(data) {
                        modalDialog.alertType('保存成功', "", "success", false, function() {
                            $modalInstance.close(data);
                        });
                    });
                }).error(function() {
                    modalDialog.alertType('保存失败', "请检查填写项", "warning", false);
                });
            };
            //取消
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };

            function savePersonalConfig(currPersonalConfig) {
                var defer = $q.defer();
                var params = {
                    serviceid: "mlf_personalcenter",
                    methodname: "save",
                    ObjectId: personalCenterConfig ? $scope.data.currPersonalConfig.PERSONALCENTERMODULEID : 0,
                    MODULNAME: currPersonalConfig.MODULNAME,
                    MODULURL: currPersonalConfig.MODULURL,
                    REFRESHTIME: currPersonalConfig.REFRESHTIME,
                    VISIBLE: $scope.isVisible, //是否可见
                    MODULEORDER: $scope.selectedConfig.value, //排序

                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                    //data = data.replace(/\"/g, "");
                    defer.resolve(data);
                });
                return defer.promise;
            }
            /**
             * [selectVisible description]选择是否可见
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.selectVisible = function(item) {
                $scope.isVisible = item.value;
            };
            /**
             * [initAllPersonalConfigs description]获取所有个人中心配置
             * @return {[type]} [description]
             */
            function initAllPersonalConfigs() {
                var params = {
                    "serviceid": "mlf_personalcenter",
                    "methodname": "query"
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    var configDatas = data.DATA;
                    for (var key in configDatas) {
                        $scope.personalConfigJson.push({
                            name: configDatas[key].MODULNAME,
                            value: configDatas[key].MODULEORDER
                        });
                    }
                    $scope.personalConfigJson.unshift({
                        name: "最前面",
                        value: -1
                    });
                    $scope.selectedConfig = angular.copy($scope.personalConfigJson[0]);
                    personalCenterConfig !== "" ? getCurrConfig() : "";
                });
            }
            //获取前一级栏目
            $scope.querySelectConfig = function() {
                $scope.data.currPersonalConfig.MODULEORDER = $scope.selectedConfig.value;
            };

            //初始化前一级栏目
            function getCurrConfig() {
                var i = 0;
                while (i < $scope.personalConfigJson.length) {
                    if ($scope.personalConfigJson[i].value === $scope.data.currPersonalConfig.MODULEORDER) {
                        $scope.personalConfigJson.splice(i, 1);
                        $scope.selectedConfig = angular.copy($scope.personalConfigJson[i - 1]);
                    } else {
                        i++;
                    }
                }
            }
        }
    ]);
